import styled from "styled-components";

import { useBIMClass, useParameter } from "../../../../modules/shared-entities";
import { Card, CardFace2, CardSkeleton } from "../../../../modules/ui-kit";

const StyledCard = styled(Card)`
    color: #fff;

    & > div {
        flex: 1 1 auto;
    }

    & > span {
        flex: none;
    }

    .bimclass {
        font-size: 1.2rem;
        opacity: .6;

        &:not(:empty)::before {
            content: " of ";
            font-size: .8rem;
            opacity: .4;
        }
    }

    .type {
        opacity: .3;
        text-align: right;
        width: 8rem;
    }

    &:hover {
        .bimclass {
            opacity: 1;
        }

        .type {
            opacity: .5;
        }
    }
`;

export default function RevitValueCard(props) {
    const { bimClassID, parameterID, ...restProps } = props;

    const parameterQuery = useParameter(parameterID);
    const bimClassQuery = useBIMClass(bimClassID);

    if (parameterQuery.loading || bimClassQuery.loading) return <CardSkeleton />;

    return (
        <StyledCard { ...restProps }>
            <CardFace2>
                <span className="name fluid-accent">{ parameterQuery.data.parameter.name[0].text }</span>
            </CardFace2>
            <span className="bimclass">{ bimClassQuery.data?.bimClass?.data?.name?.[0]?.text ?? "" }</span>
        </StyledCard>
    );
}
